import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { IExtractedProForma } from 'types/db/ExtractedProForma';

export interface IExtractedProFormaQueryParams {
    organizationId: string;
    dealId: number;
    extractedProFormaId: number;
}

const getExtractedProForma = async (
    { organizationId, dealId, extractedProFormaId }: IExtractedProFormaQueryParams,
): Promise<IExtractedProForma> => {
    const response = await axiosInstance.get(API_ENDPOINTS.EXTRACTED_PRO_FORMA(organizationId, dealId, extractedProFormaId));
    return response.data;
};

export const useGetExtractedProForma = ({ organizationId, dealId, extractedProFormaId }: IExtractedProFormaQueryParams) => useQuery({
    queryKey: ['extractedProForma', dealId, extractedProFormaId],
    queryFn: () => getExtractedProForma({ organizationId, dealId, extractedProFormaId }),
    enabled: !!organizationId && !!extractedProFormaId,
});

export default useGetExtractedProForma;
